<template>
  <div>
    <Header
      title="Facebook"
      subtitle=""
      :has-separator="false"
    ></Header>

    <div>
			<v-btn
        v-if="newForm"
				class="pa-5 mb-8 b text-capitalize"
				height="50px"
				outlined
				@click="openForm">
				<img class="pr-3" src="../../../../static/images/add-circle-black.svg"/><span class="ff">Novo formulário</span>
			</v-btn>
		</div>

    <component :is="currentView"></component>

    <v-dialog
      v-model="dialog"
      width="812" height="352"
    >
      <v-card>
        <v-card-title class="text-h5 white lighten-1 d-flex justify-space-between">
          <span>
            Informações do formulário
          </span>
          <button @click="closeModal">
            <img style="width: 40px" src="../../../../static/images/close-grey.svg" />
          </button>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="d-flex flex-column">
          <label class="mt-5 mb-2">ID Facebook</label>
          <input
            ref="id_email"
            v-model="id_form"
            class="b rounded">
          <label class="mt-5 mb-2" fro="id_email">XPROMO</label>
          <input
            ref="id_email"
            v-model="id_source"
            class="b rounded"
          >
          <label class="mt-5 mb-2">List Code</label>
          <input
            ref="id_email"
            v-model="list_code"
            class="b rounded"
          >
          <label class="mt-5 mb-2">Página email</label>
          <input
            ref="id_email"
            v-model="email_page"
            class="b rounded"
          >
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            width="120"
            height="50"
            class="ma-3"
            color="var(--red)"
            :disabled="disabled"
            @click="submitEmail"
          >
            <img class="mr-2" :src="disabled ? '../../../../static/images/save_grey.svg' : '../../../../static/images/save.svg'" />
            Salvar
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>

</template>
<script>
// Components
import Header from '@/components/Header.vue'
import FacebookList from './FacebookList.vue'

// Libs
import { mapMutations, mapState, mapActions } from 'vuex'

// mixins
import toaster from '@/mixins/toaster.js'

// Token
import VueCookies from 'vue-cookies'

export default {
  mixins: [
    toaster
  ],
  components: {
    Header,
    FacebookList,
  },
  data () {
    return {
      currentView: FacebookList,
      dialog: false,
      id_form: "",
      id_source: "",
      list_code: "",
      email_page: "",
      disabled: true
    }
  },
  computed: {
    ...mapState('Facebook', {
      newForm: 'newForm'
    })
  },
  methods: {
    ...mapMutations('Facebook', {
      setNewForm: 'SET_NEW_FORM',
      setLoading: 'SET_LOADING',
      unsetFacebookToEdit: 'UNSET_FACEBOOK_TO_EDIT',
      setStatusFilter: 'SET_STATUS_FILTER',
      setProductFilter: 'SET_PRODUCT_FILTER',
    }),
    ...mapActions('Facebook', {
      postFacebook: 'postFacebook',
      getAllForms: 'getAllForms'
    }),
    openForm () {
      this.dialog = true
    },
    async fetchForms () {
			const token = VueCookies.get('jwt-login')
			try {
				this.setStatusFilter(null);
				this.setProductFilter('');
				await this.getAllForms({ token: token });
			} catch (error) {
				this.toaster(
					error.message,
					"red",
					true
				);
			}
		},
    async submitEmail() {
      this.setLoading(true)
      const { list_code, id_form, id_source, email_page } = this
      if (this.id_form.length <= 20) {
      const token = VueCookies.get('jwt-login')
        try {
          const response = await this.postFacebook([
            {
              list_code,
              id_form,
              id_source,
              email_page,
              updated_at: new Date(),
              created_at: new Date(),
            },
            token,
          ]);

          if (response.status >= 400) {
            throw new Error(response.data.message);
          } else {
            this.toaster("Comunicação criada com sucesso", "success", true);
            this.setLoading(false);
            this.fetchForms()
            this.dialog = false
          }
        } catch (e) {
          this.unsetFacebookToEdit();
          this.toaster(e.message, "danger", true);
        }
      } else {
        this.setLoading(false);
        this.toaster(
          `O valor de ID do Formulário não pode ser maior que 20 caracteres`,
          "warning",
          true
        );
      }
    },
    handleData() {
      if (this.checkFields()) return (this.disabled = false);
      return (this.disabled = true);
    },
    checkFields() {
      const { id_form, id_source, list_code, email_page } = this;
      return id_form && id_source && list_code && email_page;
    },
    closeModal () {
      this.id_form = ''
      this.id_source = ''
      this.list_code = ''
      this.email_page = ''
      this.dialog = false
    },
  },
  watch: {
    id_form() {
      this.handleData();
    },
    list_code() {
      this.handleData();
    },
    id_source() {
      this.handleData();
    },
    email_page() {
      this.handleData();
    },
  },
}
</script>
<style lang="scss" scoped>
.b {
	border: 2px solid var(--grey-day-030);
}

label {
  font-size: 16px;
}

input {
  padding-left: 8px;
  height: 48px;
}

</style>


// WEBPACK FOOTER //
// src/components/Contents/Facebook/Facebook.vue